import styled from 'styled-components/macro';

import { paragraph } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const Button = styled.button`
  ${paragraph}

  background: none;
  border-radius: 17px;
  display: inline-block;
  margin-right: 10px;
  padding: 7px 16px 6px;

  &,
  &:hover {
    text-decoration: none;
  }

  ${({ theme }: IWithThemeProps) => `
    border: 1px solid ${theme.topForegroundPrimary};
    color: ${theme.topForegroundPrimary};
  `}
`;
